import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<Actions.CHANGE_PASSWORD_ASYNC, Actions.CHANGE_PASSWORD_SUCCESS, Actions.CHANGE_PASSWORD_FAIL>,
): State => {
  switch (action.type) {
    case Actions.CHANGE_PASSWORD_ASYNC:
    case Actions.CHANGE_PASSWORD_SUCCESS:
    case Actions.CHANGE_PASSWORD_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
